interface Props {
  keys: string[]
}

export default function Keys({ keys }: Props) {
  return (
    <span className="keys">
      {keys.map((key, i) => (
        <span key={`${key}-${i}`}>
          <kbd className="key">{key}</kbd>
          {i < keys.length - 1 && <span className="key-plus">+</span>}
        </span>
      ))}
    </span>
  )
}
